import React, { useState } from "react";
import FormControl from "@mui/material/FormControl";
import { InputField } from "../../../../../library/custom/textBox/InputField";
import DatePicker from "../../../../../library/custom/datePicker/DatePicker";
import TImePicker from "../../../../../library/custom/timePicker/TImePicker";
import { getFormatedDate } from "../../../../../utils/helper";
import FormLabels from "../../../../../library/custom/formLabel/FormLabels";
import Card from "../../../../../library/custom/card/Card";
import { Grid } from "@mui/material";
import SelectMenu from "../../../../../library/custom/selectMenu/SelectMenu";
import RadioGroup from "@mui/material/RadioGroup";
import RadioButton from "../../../../../library/custom/radioButton/RadioButton";
import TextEditor from "../../../../../library/custom/textEditor/TextEditor";
import { NumberField } from "../../../../../library/custom/numberField/numberField";
import Checkbox from "../../../../../library/checkbox/checkbox";
import { handleMinsonChangeRainfall } from "../../../../../utils/helper";
import ViewPastRainFall from "./viewPastRainFainfall";
const SwCommonForm = (props) => {
  const { propsData, frequency } = props;

  const date = new Date();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const time = `${hours}:${formattedMinutes}`;

  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const handleClose = () => setOpen(false);

  const pastRainFallHandle = () => {
    setOpen(true);
  };
  return (
    <>
      {propsData?.getInTyFeByInTyList
        ?.filter((field) => field.isSelected)
        ?.sort((a, b) => a.sequenceNumber - b.sequenceNumber)
        ?.map((field) => {
          if (field?.key === 1 && field.isSelected && propsData?.mapId) {
            return (
              <Grid item md={6} xs={12} key={field.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Project Name"}
                    value={propsData?.formValue?.projectName}
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        projectName: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {propsData?.isProjectName &&
                  !propsData?.formValue?.projectName && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 9 && propsData?.mapId) {
            return (
              <Grid item md={6} xs={12} key={field.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Client"}
                    value={propsData?.formValue?.customerName}
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        customerName: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {propsData?.isCustomerName &&
                  !propsData?.formValue?.customerName && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 34 && propsData?.mapId) {
            return (
              <Grid item md={6} xs={12}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Inspection Name"}
                    value={propsData?.formValue?.questionSetName}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 8 && propsData?.mapId) {
            return (
              <Grid item md={6} xs={12} key={field.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Report ID"}
                    value={propsData?.formValue?.reportId}
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        reportId: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {propsData?.isReportId && !propsData?.formValue?.reportId && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 12 && propsData?.mapId) {
            return (
              <>
                <Grid item md={6} xs={12} key={field.key}>
                  <FormControl fullWidth>
                    <FormLabels label="Inspection Type" isRequired={true} />
                    <SelectMenu
                      placeholder="Please Select"
                      listData={propsData?.getSwReference?.insTypeMstList ?? []}
                      value={
                        propsData?.inspectionTypeId
                          ? propsData?.inspectionTypeId
                          : null
                      }
                      disabled={true}
                    />
                  </FormControl>

                  {propsData?.isCustomerName &&
                    !propsData?.formValue?.inspectionType && (
                      <div className="error">
                        Please enter this required field.
                      </div>
                    )}
                  {(propsData?.editMode
                    ? !propsData?.isDirectIns && parseInt(propsData?.inspectionTypeId) === 2
                    : parseInt(propsData?.inspectionTypeId) === 2) && (
                    <div className="alsoRoutine">
                      <Checkbox
                        checked={propsData?.alsoSubmitRoutineInspection}
                        onChange={() => propsData?.handleChangeDefault()}
                        label={"Also a routine Inspection"}
                      />
                    </div>
                  )}
                </Grid>

                {(propsData?.inspectionTypeId === 1 ||
                  propsData?.inspectionTypeId === 3 ||
                  propsData?.alsoSubmitRoutineInspection) && (
                  <Grid lg={6} xs={12} sm={6} md={6} item>
                    <FormControl fullWidth>
                      <FormLabels label="Frequency" isRequired={true} />
                      <SelectMenu
                        placeholder="Please Select"
                        listData={frequency ?? []}
                        value={
                          propsData?.frequencyValue
                            ? propsData?.frequencyValue
                            : null
                        }
                        onchangehandler={(e) =>
                          propsData?.handleFrequencyChange(e)
                        }
                        disabled={propsData?.disabledCheck()}
                      />
                    </FormControl>
                    {propsData?.frequencyValueError &&
                      !propsData?.frequencyValue && (
                        <p className="error">Frequency is required</p>
                      )}
                  </Grid>
                )}
                {parseInt(propsData?.frequencyValue) === 7 && (
                  <Grid item lg={6} xs={12} sm={12} md={6}>
                    <FormControl fullWidth={true}>
                      <NumberField
                        isRequired={true}
                        type="text"
                        label={"Date Range"}
                        maxLength="3"
                        value={propsData?.frequencyInDays}
                        placeholder={"Enter Frequency In Days..."}
                        onChange={(value) => propsData?.dateRangeHandler(value)}
                      />
                    </FormControl>
                    {propsData?.dateRangeError && (
                      <p className="error">Number should be between 1 to 365</p>
                    )}
                    {propsData?.errorFrequencyInDays && (
                      <p className="error">Please add frequencyInDays </p>
                    )}
                  </Grid>
                )}
              </>
            );
          } else if (field?.key === 2) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Project Number"}
                    value={propsData?.formValue?.projectNo}
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        projectNo: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {propsData?.isProjectNo && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 10) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormLabels
                  label={"Date of Inspection"}
                  isRequired={field.isMandatory}
                />
                <DatePicker
                  onChangeHandler={(e) => {
                    let selectedDate = e ?? date;
                    if (selectedDate > date) {
                      selectedDate = date;
                    }
                    propsData?.setFormValue({
                      ...propsData?.formValue,
                      dateofInspection: selectedDate,
                    });
                  }}
                  value={
                    propsData?.formValue?.dateofInspection
                      ? propsData?.formValue?.dateofInspection
                      : getFormatedDate(date)
                  }
                  maxDateEnable={false}
                  isError={propsData?.isDateofInspection}
                  errorMsg={
                    propsData?.isDateofInspection
                      ? "Please enter this required field"
                      : ""
                  }
                />
              </Grid>
            );
          } else if (field?.key === 3) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <FormLabels
                    label={"Time of Inspection"}
                    isRequired={field.isMandatory}
                  />
                  <TImePicker
                    disabled={false}
                    value={
                      propsData?.formValue.timeofInspection
                        ? propsData?.formValue.timeofInspection
                        : time
                    }
                    onChangeTimeHandler={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        timeofInspection: e.target.value,
                      })
                    }
                  />
                </FormControl>
                {propsData?.isTimeofInspection &&
                  !propsData?.formValue.timeofInspection && (
                    <div className="error">
                      Please select this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 13) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Name of Inspector"}
                    value={propsData?.formValue?.primaryInspector}
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        primaryInspector: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {propsData?.isPrimaryInspector &&
                  !propsData?.formValue?.primaryInspector && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 21) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Inspector's phone number"}
                    value={propsData?.formValue?.phoneNumber}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 36) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Inspector's Email"}
                    value={propsData?.formValue?.email}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 4) {
            return (
              <Grid item md={12} xs={12} key={field?.key}>
                <FormLabels
                  label="Weather at Time of Inspection"
                  isRequired={field.isMandatory}
                />
                <Card
                  staticCardData={true}
                  cardData={propsData?.weather ?? []}
                  selectedVehicleAccident={
                    propsData?.formValue.WeatherAtTimeofInspection
                  }
                  cardClickHandler={(val) =>
                    propsData?.setFormValue({
                      ...propsData?.formValue,
                      WeatherAtTimeofInspection: val,
                    })
                  }
                />
                {propsData?.isWeatherAtTimeofInspection &&
                  !propsData?.formValue.WeatherAtTimeofInspection.value && (
                    <div className="error">
                      Please select this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 17) {
            return (
              <Grid item md={12} xs={12} key={field?.key}>
                <FormLabels
                  label="Soil Condition"
                  isRequired={field.isMandatory}
                />
                <Card
                  staticCardData={true}
                  cardData={propsData?.getSwReference?.soilList ?? []}
                  selectedVehicleAccident={propsData?.formValue.soilTypeId}
                  cardClickHandler={(val) =>
                    propsData?.setFormValue({
                      ...propsData?.formValue,
                      soilTypeId: val,
                    })
                  }
                />
                {propsData?.isSoilTypeId &&
                  !propsData?.formValue.soilTypeId.value && (
                    <div className="error">
                      Please select this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 14) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <FormLabels
                    label="Stage of Construction"
                    isRequired={field.isMandatory}
                  />
                  <SelectMenu
                    placeholder="Please Select"
                    listData={
                      propsData?.getSwReference?.constructionStageList ?? []
                    }
                    value={
                      propsData?.formValue?.constructionStageId
                        ? propsData?.formValue?.constructionStageId
                        : null
                    }
                    onchangehandler={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        constructionStageId: e.target.value,
                      })
                    }
                  />
                </FormControl>
                {propsData?.isStageOfConstruction &&
                  !propsData?.formValue.constructionStageId && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 6) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormLabels
                  label={"Sample Taken"}
                  isRequired={field.isMandatory}
                />
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  className="radioGroup"
                >
                  <RadioButton
                    checked={propsData?.formValue.sampleTaken == "3"}
                    value="3"
                    label="Yes"
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        sampleTaken: e.target.value,
                      })
                    }
                  ></RadioButton>
                  <RadioButton
                    checked={propsData?.formValue.sampleTaken == "1"}
                    value="1"
                    label="No"
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        sampleTaken: e.target.value,
                      })
                    }
                  ></RadioButton>
                </RadioGroup>
                {propsData?.isSampleTaken &&
                  !propsData?.formValue.sampleTaken && (
                    <div className="error">
                      Please select this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 5) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    type="text"
                    label={"Rainfall Amount (inches)"}
                    value={propsData?.formValue?.rainfall}
                    onChange={(event, value) =>
                      handleMinsonChangeRainfall(
                        event,
                        propsData?.setFormValue,
                        propsData?.formValue
                      )
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                <div className="viewPast7RainFall" onClick={pastRainFallHandle}>
                  View past 7 days rainfall data
                </div>
                <ViewPastRainFall
                  open={open}
                  modalData={modalData}
                  handleClose={handleClose}
                  swRainFallDataModalData={propsData?.swRainFallDataModalData}
                />
                {propsData?.isRainFallError &&
                  !propsData?.formValue?.rainfall && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 16) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth className="approximate">
                  <InputField
                    fullWidth={true}
                    disabled={false}
                    type="text"
                    label={"Current Approximate Disturbed Acreage"}
                    value={propsData?.formValue?.disturbedAcreage}
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        disturbedAcreage: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {propsData?.isCurrentApproximateDisturbedAcreage &&
                  !propsData?.formValue?.disturbedAcreage && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 19) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Site Name"}
                    value={
                      propsData?.formValue?.isStandalone === false
                        ? propsData?.inspectionHeaderDetails?.siteName
                        : "N/A"
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 18) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <FormLabels
                    label="Construction Activity"
                    isRequired={field.isMandatory}
                  />
                  <SelectMenu
                    placeholder="Please Select"
                    listData={
                      propsData?.getSwReference?.constructionActivity ?? []
                    }
                    value={propsData?.constructionActivityId || null}
                    onchangehandler={(e) =>
                      propsData?.handleConstructionActivitySetChange(e)
                    }
                    isError={propsData?.isConstructionActivityId}
                    errorMsg={
                      propsData?.isConstructionActivityId
                        ? "Please enter this required field."
                        : ""
                    }
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 20) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Division"}
                    value={propsData?.inspectionHeaderDetails?.divisionName}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 22) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Company performing inspection"}
                    value={propsData?.formValue?.companyPerformingInspection}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 23) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <FormLabels
                    label="Project Status"
                    isRequired={field.isMandatory}
                  />
                  <RadioGroup
                    row
                    name="row-radio-buttons-group"
                    className="radioGroup"
                  >
                    <RadioButton
                      checked={propsData?.projectStatus === "1"}
                      value="1"
                      label="Active"
                      onChange={(e) =>
                        propsData?.setProjectStatus(e.target.value)
                      }
                    />
                    <RadioButton
                      checked={propsData?.projectStatus === "2"}
                      value="2"
                      label="Inactive"
                      onChange={(e) =>
                        propsData?.setProjectStatus(e.target.value)
                      }
                    />
                  </RadioGroup>
                </FormControl>
                {propsData?.isProjectStatus && (
                  <p className="error">Please enter this required field.</p>
                )}
              </Grid>
            );
          } else if (field?.key === 24) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"State"}
                    value={propsData?.inspectionHeaderDetails?.stateName}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 25) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Address"}
                    value={propsData?.inspectionHeaderDetails?.address ? propsData?.inspectionHeaderDetails?.address : "N/A"}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 27) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Job Title"}
                    value={propsData?.formValue.jobTitle}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 26) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Certification Number"}
                    value={propsData?.formValue?.certificationNumber}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 39) {
            return (
              <Grid item md={12} xs={12} className="companyPerforming">
                <div className="companyPerformingTitle">
                  Company Performing Inspection Address
                </div>
                <div className="companyPerforming">
                  Address Line 1:{" "}
                  <span> {propsData?.formValue.clientAddress1 || "N/A"}</span>
                </div>
                {propsData?.formValue.clientAddress2 &&
                  propsData?.formValue.clientAddress2 !== "N/A" && (
                    <div className="companyPerforming">
                      Address Line 2:{" "}
                      <span> {propsData?.formValue.clientAddress2}</span>
                    </div>
                  )}
                <div className="companyPerforming columnBox">
                  <div className="column">
                    State:{" "}
                    <span> {propsData?.formValue.clientState || "N/A"}</span>
                  </div>
                  <div className="column">
                    City:{" "}
                    <span>{propsData?.formValue.clientCity || "N/A"}</span>
                  </div>
                </div>
                <div className="companyPerforming">
                  Zip Code:{" "}
                  <span>{propsData?.formValue.clientZipCode || "N/A"}</span>
                </div>
              </Grid>
            );
          }
          return null;
        })}

      {(() => {
        const permitFields = [7, 15, 28, 37, 38];
        const selectedPermitFields = propsData?.getInTyFeByInTyList?.filter(
          (field) => permitFields.includes(field.key) && field.isSelected
        );
        if (selectedPermitFields?.length > 0) {
          return (
            <Grid item md={12} xs={12} className="northCarolinaOverride">
              <div className="commonTableBoxNorth">
                <div className="commonTableBoxNorthTitle">Permit Details</div>
                <div className="tableWrapper">
                  <table>
                    <thead>
                      <tr className="tableHead">
                        {selectedPermitFields.find((f) => f.key === 7) && (
                          <th>Permit Number</th>
                        )}
                        {selectedPermitFields.find((f) => f.key === 15) && (
                          <th>Permit Enforcement</th>
                        )}
                        {selectedPermitFields.find((f) => f.key === 28) && (
                          <th>Permittee Address</th>
                        )}
                        {selectedPermitFields.find((f) => f.key === 37) && (
                          <th>Permit Approval Date</th>
                        )}
                        {selectedPermitFields.find((f) => f.key === 38) && (
                          <th>Permit Expiration Date</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {propsData?.listPermitte?.length > 0 ? (
                        propsData?.listPermitte.map((x, index) => (
                          <tr className="tableBody" key={index}>
                            {selectedPermitFields.map((field) => {
                              let value = "N/A";
                              switch (field.key) {
                                case 7:
                                  value = x.permitteOrNPDESNumber || "N/A";
                                  break;
                                case 15:
                                  value = x.permitteEnforcement || "N/A";
                                  break;
                                case 28:
                                  value = x.permitteAddress || "N/A";
                                  break;
                                case 37:
                                  value = x.permitteApprovalDate || "N/A";
                                  break;
                                case 38:
                                  value = x.permitteExpirationDate || "N/A";
                                  break;
                                default:
                                  value = "N/A";
                              }
                              return <td key={field.key}>{value} </td>;
                            })}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          {selectedPermitFields.map((field, index) => (
                            <td key={index}>N/A</td>
                          ))}
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Grid>
          );
        }
        return null;
      })()}

      {propsData?.getInTyFeByInTyList
        ?.filter((field) => field.isSelected)
        ?.sort((a, b) => a.sequenceNumber - b.sequenceNumber)
        ?.map((field) => {
          if (field?.key === 29) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormLabels
                  label={"Has rainfall been checked/documented daily"}
                  isRequired={field.isMandatory}
                />
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  className="radioGroup"
                >
                  <RadioButton
                    checked={propsData?.formValue.isRainfallChecked == "1"}
                    value="1"
                    label="Yes"
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        isRainfallChecked: e.target.value,
                      })
                    }
                  ></RadioButton>
                  <RadioButton
                    checked={propsData?.formValue.isRainfallChecked == "2"}
                    value="2"
                    label="No"
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        isRainfallChecked: e.target.value,
                      })
                    }
                  ></RadioButton>
                </RadioGroup>
                {propsData?.isRainfallChecked &&
                  !propsData?.formValue.isRainfallChecked && (
                    <div className="error">
                      Please select this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 30) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormLabels
                  label={"Site Assessment"}
                  isRequired={field.isMandatory}
                />
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  className="radioGroup"
                >
                  <RadioButton
                    checked={propsData?.formValue.siteAssessment == 1}
                    value="1"
                    label="Yes"
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        siteAssessment: e.target.value,
                      })
                    }
                  ></RadioButton>
                  <RadioButton
                    checked={parseInt(propsData?.formValue.siteAssessment) == 2}
                    value="2"
                    label="No"
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        siteAssessment: e.target.value,
                      })
                    }
                  ></RadioButton>
                </RadioGroup>
                {propsData?.isSiteAssessment &&
                  !propsData?.formValue.siteAssessment && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 31) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    type="text"
                    label={"Assessor's TN PE registration number"}
                    value={propsData?.formValue?.tnpeNumber}
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        tnpeNumber: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {propsData?.isTnpeNumber &&
                  !propsData?.formValue.tnpeNumber && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 32) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    type="text"
                    label={"Assessor's TNEPSC Level II / CPESC number"}
                    value={propsData?.formValue?.cpescNumber}
                    onChange={(e) =>
                      propsData?.setFormValue({
                        ...propsData?.formValue,
                        cpescNumber: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {propsData?.isCpescNumber &&
                  !propsData?.formValue.cpescNumber && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          }
          return null;
        })}

      <Grid item md={12} xs={12}>
        <FormLabels label="General Comments" />

        <TextEditor
          value={propsData?.formValue?.generalComments}
          placeholder={"Enter Here..."}
          onChange={(e) =>
            propsData?.setFormValue((prevFormValue) => ({
              ...prevFormValue,
              generalComments: e,
            }))
          }
        />
      </Grid>
    </>
  );
};

export default SwCommonForm;